import React, { useState, useEffect } from 'react';
import DataTable from './components/DataTable.js';
import MapVeto from './components/MapVeto.js';
import socket, { onIdentity, requestState } from './config/socket';
// import background from "./img/placeholder.webp";

const ViewerView = () => {
  const [teams, setTeams] = useState([]);
  const [team1, setTeam1] = useState('Team 1');
  const [team2, setTeam2] = useState('Team 2');
  const [ready, setready] = useState();
  const [players, setPlayers] = useState([]);
  const [playersMatch, setPlayersMatch] = useState([]);
  const [match, setMatch] = useState([]);

  // Wer sitzt vor diesem Bildschirm? Es gibt keinen Beamer -- jeder schaut auf
  // seinen eigenen Monitor, also muss diese Seite persoenlich sein.
  const [identity, setIdentity] = useState(null);
  const [lobby, setLobby] = useState({ status: 'closed', claims: [] });
  const [veto, setVeto] = useState(null);
  const [settings, setSettings] = useState({ connectUrl: null });

  useEffect(() => onIdentity(setIdentity), []);

  useEffect(() => {
    socket.on('lobby:state', setLobby);
    socket.on('veto:state', setVeto);
    socket.on('settings:state', setSettings);
    socket.on('auth:revoked', () => setIdentity(null));

    return () => {
      socket.off('lobby:state', setLobby);
      socket.off('veto:state', setVeto);
      socket.off('settings:state', setSettings);
      socket.off('auth:revoked');
    };
  }, []);

  // In welchem Team stehe ich? -1 wenn nicht angemeldet oder noch nicht verteilt.
  const myTeamIndex =
    identity && identity.role === 'player' && teams.length
      ? teams.findIndex((team) => team.some((u) => u.steamID === identity.playerId))
      : -1;

  const isMe = (user) => identity && identity.role === 'player' && user.steamID === identity.playerId;

  // Teams in Echtzeit vom Server empfangen
  useEffect(() => {
    socket.on('updateTeams', (newTeams) => {
      setTeams(newTeams);
    });

    socket.on('updateTeam1', (team1) => {
      setTeam1(team1);
    });

    socket.on('updateTeam2', (team2) => {
      setTeam2(team2);
    });

    socket.on('ready', (ready) => {
      setready(ready);
      // console.log('Ready', ready)
    });

    socket.on('player_stats', (data) => {
      setPlayers(data);
      console.log (data)
    });

    socket.on('player_match_stats', (data1) => {
      setPlayersMatch(data1);
      console.log (data1)
    });

    socket.on('match_stats', (data2) => {
      setMatch(data2);
      console.log (data2)
    });

    // Der Socket besteht schon, seit die Seite geladen wurde -- beim Wechsel
    // von /join hierher schickt der Server von sich aus nichts mehr.
    requestState();

    // Cleanup bei Komponenten-Demontage
    return () => {
      socket.off('updateTeams');
      socket.off('updateTeam1');
      socket.off('updateTeam2');
      socket.off('ready');
      socket.off('player_stats');
      socket.off('player_match_stats');
      socket.off('match_stats');
    };
  }, []);

  return (
    // <div className='bg-scroll bg-center min-h-screen' style={{ backgroundImage: `url(${background})` }} >
      <div className='mx-8'>
        <div className='mx-8 max-w-2xl sm:mx-auto py-10 sm:py-16'>
          <h1 className='text-2xl pb-6'>Otter-Team View</h1>

          {identity && identity.role === 'player' && (
            <div className='mb-8 rounded-lg bg-gray-50 px-4 py-3'>
              Du bist <span className='font-semibold'>{identity.playerName}</span>
              {myTeamIndex === 0 && (
                <span> - du spielst bei <span className='font-semibold'>{team1}</span></span>
              )}
              {myTeamIndex === 1 && (
                <span> - du spielst bei <span className='font-semibold'>{team2}</span></span>
              )}
            </div>
          )}

          {!identity && lobby.status === 'open' && (
            <div className='mb-8 rounded-lg bg-gray-50 px-4 py-3 text-sm'>
              Die Lobby ist offen -{' '}
              <a className='font-semibold underline' href='/join'>
                hier anmelden
              </a>
              , damit die Seite weiss, wer du bist.
            </div>
          )}

          {teams.length > 0 ? (
            <div className='mt-4 grid grid-cols-1 sm:grid-cols-3 gap-y-3 gap-x-4'>
              <div>
                <h2 className='mb-8 text-xl font-bold'>
                  {team1}
                  {myTeamIndex === 0 && (
                    <span className='ml-2 align-middle rounded-full bg-lime-200 px-2 py-0.5 text-xs font-medium text-gray-800'>
                      dein Team
                    </span>
                  )}
                </h2>
                <ul>
                  {teams[0].map((user, index) => (
                    <li key={index}>
                        <div className='flex flex-row mb-4'>
                          <img src={user.imgUrl} alt={user.nickName} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                          <span className={'ml-2 my-auto' + (isMe(user) ? ' font-semibold' : '')}>
                            {user.nickName} ({user.name})
                          </span>
                        </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h2 className='p-4 sm:p-16 text-3xl font-bold'>VS</h2>
              </div>
              <div>
                <h2 className='mb-8 text-xl font-bold'>
                  {team2}
                  {myTeamIndex === 1 && (
                    <span className='ml-2 align-middle rounded-full bg-lime-200 px-2 py-0.5 text-xs font-medium text-gray-800'>
                      dein Team
                    </span>
                  )}
                </h2>
                <ul>
                  {teams[1].map((user, index) => (
                    <li key={index}>
                        <div className='flex flex-row mb-4'>
                          <img src={user.imgUrl} alt={user.nickName} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                          <span className={'ml-2 my-auto' + (isMe(user) ? ' font-semibold' : '')}>
                            {user.nickName} ({user.name})
                          </span>
                          </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div></div>
              <div className='flex flex-col items-center'>
              {/* {ready ? (
                <div>
                <button
                      type="button"
                      className="text-gray-900 bg-gradient-to-r from-teal-200 to-lime-200 hover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200 focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-teal-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href='steam://connect/138.68.99.57:27015';
                        }}
                  > Connect to server</button>
                  </div>
                      ):(
                         <div></div>
                      )} */}

                       {/* mit oberen code nehm ich das komplett aus dem DOM */}

                {/* Die Adresse kommt aus den Admin-Einstellungen. Steht dort
                    nichts, gibt es nichts zu verbinden -- frueher stand hier
                    eine feste IP, die nur ein Rebuild aendern konnte. */}
                <div
                  className={`transition-opacity duration-800 ${
                    ready && settings.connectUrl
                      ? "opacity-100 pointer-events-auto  mb-20"
                      : "opacity-0 pointer-events-none"
                  }`}
                >
                  <button
                    type="button"
                    className="text-gray-900 bg-gradient-to-r from-teal-200 to-lime-200 hover:bg-gradient-to-l hover:from-teal-200 hover:to-lime-200 focus:ring-4 focus:outline-none focus:ring-lime-200 dark:focus:ring-teal-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                    onClick={(e) => {
                      e.preventDefault();
                      if (settings.connectUrl) window.location.href = settings.connectUrl;
                    }}
                  >
                    Connect to server
                  </button>
                  <p className="pt-2 text-xs text-gray-400">{settings.gameHost}:{settings.gamePort}</p>
                </div>
              </div>
              <div></div>

            </div>
          ) : (
            <p>Warten auf generierte Teams...</p>
          )}

        <MapVeto veto={veto} identity={identity} teamNames={[team1, team2]} isAdmin={false} />

        <DataTable data={players} matches={match} matchDetails ={playersMatch}/>

        </div>
      </div>
    // </div>
  );
};

export default ViewerView;
